<template>
    <div>
        <a 
            data-type="confirm" 
            @click="confirmDelete(salepageId)" 
            class="dropdown-item js-sweetalert"
            style="cursor: pointer;">
                <i class="fa fa-trash-o mr-2"></i> ลบ Sale Page
        </a>
    </div>
</template>

<script>
export default {
    props: ["salepageId", "shop"],
    data() {
        return {};
    },

    created() {},

    methods: {
        confirmDelete(id) {
            this.$swal({
                icon: "warning",
                title: "ต้องการลบ Sale Page นี้ ใช่ไหม",
                text: "เมื่อกดยืนยัน Sale Page นี้จะถูกลบ",
                confirmButtonText: "ยืนยัน",
                showCancelButton: true,
                cancelButtonText: "ยกเลิก",
                reverseButtons: true
            }).then(result => {
                if (result.isConfirmed) {
                    this.deleteProduct(id);
                }
            });
        },
        async deleteProduct(id) {
            await axios
                .delete(`/backend/s/${this.shop}/salepages/${id}`)
                .then(res => {
                    window.location.reload();
                });
        }
    }
};
</script>
